module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Roulette-40b29b748135b58db2590d63fc9469e6.svg";